import { AccountFeatures } from "@lightspeed-invoicing/core-client/frontend"
import React, { useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { useDispatch } from "react-redux"
import ButtonWrapper from "../../../../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"
import { getPriceListName } from "../../../../name-helpers/priceListNameHelper"
import NewPriceListModal from "../../../../price-list/components/NewPriceListModal"
import { displayAlert } from "../../../../state/alert/reducer"
import { isError } from "../../../../state/helpers/Error"
import IntlProps from "../../../../state/helpers/IntlProps"
import PriceList from "../../../../state/price-list/PriceList"
import PriceListService from "../../../../state/price-list/PriceListService"
import { AlertVariant } from "../../../alert/Alert"
import Icon from "../../../icon/icon.component.jsx"

const PriceListCreationButton = (props: IntlProps) => {
    const dispatch = useDispatch()
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const createPriceList = async (
        title: string,
        objectType: string,
        creditMemoContactReceiverId: string,
        docGeneratedStatus: string,
    ) => {
        setLoading(true)
        const res = await PriceListService.CreatePriceList(
            {
                title,
                objectType,
                creditMemoContactReceiverId,
                docGeneratedStatus,
            }
        )

        if (isError(res)) {
            dispatch(displayAlert({ type: AlertVariant.DANGER, message: "Error: Could not create order form" }))
            setLoading(false)
        } else {
            const id = (res as PriceList).getId()
            setLoading(false)
    
            if (id) {
                window.location.href = `/price-lists/${id}/edit`
            }
        }
    }

    return (
        <>
            {openModal && (
                <NewPriceListModal
                    show={openModal}
                    onHide={handleCloseModal}
                    onCreate={createPriceList}
                    isLoading={loading}
                />
            )}
            <ButtonWrapper
                accountFeatureKey={AccountFeatures.FeaturePriceList}
                onClick={handleOpenModal}
                redirectToAccount={true}
                className="btn btn-primary w-50"
                protectedClassName="btn btn-primary w-50"
                premium={false}
            >
                <span>
                    <Icon value={"plus-circle"} />
                    <FormattedMessage
                        id="listing.search.price_list_create_btn"
                        defaultMessage="New {priceList}"
                        values={{
                            priceList: getPriceListName(props.intl)
                        }}
                    />
                </span>
            </ButtonWrapper>
        </>
    )
}

export default injectIntl(PriceListCreationButton)


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/PriceListCreationButton.tsx